import { Icon } from "@rsuite/icons";
import React, { useState } from "react";
import { MdPlayCircle } from "react-icons/md";
import { Button, Panel, Stack } from "rsuite";
import { Color } from "rsuite/esm/internals/types/colours";

interface ActionPanelProps {
    title: string;
    description: string;
    disabled?: boolean;
    loading?: boolean;
    actionBar?: React.ReactNode
    onClick?: () => Promise<void> | void;
    color?: Color;
    doneContent?: React.ReactNode; // 👈 Message or component to show when action is done
}
const ActionPanel: React.FC<ActionPanelProps> = ({ title, description, onClick, disabled, loading, actionBar, color, doneContent }) => {
    const [done, setDone] = useState(false);
    
    const handleClick = async () => {
        if (!onClick) return;
        const result = onClick();
        if (result instanceof Promise) {
            await result;
        }
        setDone(true);
    };
    return (
    <Panel header={
        <Stack justifyContent="space-between">
        <strong>{title}</strong>
        {actionBar || <Button 
            startIcon={<Icon as={MdPlayCircle} />} 
            appearance="ghost" 
            onClick={handleClick}
            disabled={disabled || loading}
            loading={loading}
            color={color}
        >
        {title}
        </Button>}
        </Stack>
        }>
        <p>{description}</p>
        {done && doneContent && (
            <div style={{ marginTop: 12 }}>{doneContent}</div>
        )}        
    </Panel>
    );
};

export default ActionPanel;  